module.exports = __webpack_public_path__ + "static/media/loc1_img29.5c99f911.jpg";